//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'BODEXINDEX',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: ''
      },
      dataList1: [
        {name: '>21', value: '0'},
        {name: '≤21', value: '1'}
      ],
      dataList2: [
        {name: '≥65', value: '0'},
        {name: '50~64', value: '1'},
        {name: '36~49', value: '2'},
        {name: '≤35', value: '3'}
      ],
      dataList3: [
        {value: '0', name: '0~1'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList4: [
        {name: '无慢阻肺急性加重', value: '0'},
        {name: '有1~2次', value: '1'},
        {name: '有3次以上', value: '2'}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            result += form[key]
          }
        }
      }
      if (!flag) {
        return ''
      }

      if (result >= 0 && result <= 2) {
        self.descTxt = '1级'
      } else if (result >= 3 && result <= 4) {
        self.descTxt = '2级'
      } else if (result >= 5 && result <= 6) {
        self.descTxt = '3级'
      } else if (result >= 7 && result <= 9) {
        self.descTxt = '4级'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/BODEXINDEX.vue